// extracted by mini-css-extract-plugin
module.exports = {"container":"stadt_container__3YRgd","image":"stadt_image__OF5MG"};